/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-16 15:28:11
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:07:52
 * @name: 商品对象
 * @Description: 商品对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\goods\waresGoods.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { colorGetList, goodsGetList, goodsAdd, goodsEdit, goodsDelete, goodsChangeStatus, agencyGoodsGetAllList, agencyGoodsAdd, agencyGoodsDelete } from "@/api/goodsManage/goods.api.js";
import { apiMethod } from "@/utils/decorator.js";

const waresGoods = class waresGoods {
  constructor() {
    this.options_color = []; //商品颜色可选数组
    this.options_wares = []; //商品可选数组
    this.table_wares_data = { total: 0, list: [] }; //商品表格
    this.allPianoComponey = []; //所有琴行
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取商品颜色可选数组
   */
  @apiMethod(colorGetList)
  async getOptionsColor(res) {
    if (res.code === 200) {
      this.options_color = res.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取商品表格数据
   */
  @apiMethod(goodsGetList)
  async getTableData(res) {
    if (res.code === 200) {
      this.table_wares_data.total = res.data.total;
      let list = res.data.data;
      for (let x in list) {
        let goods_level = [];
        list[x].sku.forEach(y => {
          goods_level = goods_level.concat(y.level)
        })
        list[x].goods_level = goods_level;
      }
      this.table_wares_data.list = list;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 变化商品表格中商品的状态
   */
  @apiMethod(goodsChangeStatus)
  async statusChange(res, params) {
    if (res.code === 200) {
      this.table_wares_data.list[
        this.table_wares_data.list.findIndex((x) => x.id === params.goods_id)
      ].status = params.status;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除商品
   * @param {Number} goods_id 商品id
   */
  @apiMethod(goodsDelete)
  async deleteItem(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除琴行
   */
  @apiMethod(agencyGoodsDelete)
  async deletePianoCompany(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加琴行
   * @param {Number} id 产品id
   * @param {Object} obj 添加的琴行信息
   */
  @apiMethod(agencyGoodsAdd)
  async addPianoCompany(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加产品
   * @param {Object} form 表单信息
   */
  @apiMethod(goodsAdd)
  async addProduct(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 编辑产品
   * @param {Object} form 表单信息
   */
  @apiMethod(goodsEdit)
  async editProduct(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取全部绑定琴行
   * @param {Number} id 商品级别id
   */
  @apiMethod(agencyGoodsGetAllList)
  async agencyGoodsGetAllList(res) {
    if (res.code === 200) {
      this.allPianoComponey = res.data;
    }
  }
}

export default waresGoods;